import { search } from '../../helpers/api';

export const AUTH_SERVICE_URI = '/taxonomies';
export const AUTH_BASE_URI = '/api/v1/institution-subdivisions';

export const getSubdivisions = async (data) =>
  search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}`, data);
